const PERSIAN_DIGITS = "۰۱۲۳۴۵۶۷۸۹";
const ARABIC_DIGITS = "٠١٢٣٤٥٦٧٨٩";

export const formatNumber = (num: number): string => {
  return new Intl.NumberFormat("fa-IR").format(num);
};

/** Strip separators and normalize Persian/Arabic digits to a plain digit string. */
export const parseFormattedNumber = (value: string): string =>
  value
    .replace(/[۰-۹]/g, (d) => String(PERSIAN_DIGITS.indexOf(d)))
    .replace(/[٠-٩]/g, (d) => String(ARABIC_DIGITS.indexOf(d)))
    .replace(/[^\d]/g, "");

/** Format a raw or already-formatted numeric string for display in inputs. */
export const formatNumberInput = (value: string): string => {
  const digits = parseFormattedNumber(value);
  if (!digits) return "";
  return formatNumber(Number(digits));
};
